const context: string[] = [];
let defaultContext = 'noContext';
try {
  const cont = window?.top?.location?.href?.replace("'", '');
  if (cont) defaultContext = cont;
} catch (error) {
  console.warn(error);
}

export type ContextEntry = {
  [key: string]: string;
}
export const addContext = (ctx: ContextEntry) => {
  for (const key in ctx) {
    const ctxString = `${key}('${ctx[key]}')`;
    context.push(ctxString);
  }
};

export const getContext = () => context;
export const getDefaulContext = () => defaultContext;
